import {visibleInViewport} from './visible-in-viewport.js'
import {oxgGenerateUniqueId} from './generate-unique-id.js' 

function muteUnmuteVimeoPlayer(button, videoPlayers) {
    let playerId = button.getAttribute('data-player-id')
    for (let i = 0; i < videoPlayers.length; i++) {
        let playerObject = videoPlayers[i]
        if (playerObject.id == playerId) {
            playerObject.player.getMuted().then(function(muted) {
                console.log(muted)
                if (muted) {
                    console.log('attempting to unset mute')
                    playerObject.player.setMuted(false).then(function(){
                        console.log('unmute succesful')
                        playerObject.player.setVolume(1).then(function(volume) {
                            console.log('Volume: ' + volume)
                        })
                    })
                    button.parentNode.parentNode.setAttribute('data-is-muted', 'false')
                } else {
                    console.log('attempting to mute')
                    playerObject.player.setMuted(true).then(function(){
                        console.log('mute succesful')
                        playerObject.player.setVolume(0).then(function(volume) {
                            console.log('Volume: ' + volume)
                        })
                    })
                    button.parentNode.parentNode.setAttribute('data-is-muted', 'true')
                }
            })
            break
        }
    }
}

function playPauseVimeoPlayer(button, videoPlayers) {
    let playerId = button.getAttribute('data-player-id')
    for (let i = 0; i < videoPlayers.length; i++) {
        let playerObject = videoPlayers[i]
        if (playerObject.id == playerId) {
            playerObject.player.getPaused().then(function(paused) {
                if (paused) {
                    playerObject.player.play()
                    button.parentNode.parentNode.setAttribute('data-is-playing', 'true')
                } else {
                    playerObject.player.pause()
                    button.parentNode.parentNode.setAttribute('data-is-playing', 'false')
                }
            })
            break
        }
    }
}

class OxgVimeoVideos {
    constructor(name = 'defaultName', autoInit = true) {
        this.name = name
        this.players = new Array
        this.observers = new Array
        if(autoInit) this.init()
    }
    getStandardTippingPoint() {
        return 0.5
    }
    init() {
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                let ratio = Math.round(entry.intersectionRatio*10)/10
                let threshold = entry.target.getAttribute('data-threshold') ? entry.target.getAttribute('data-threshold') : this.getStandardTippingPoint()
                entry.target.setAttribute('data-intersection-ratio', ratio)
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-intersecting')
                    entry.target.classList.remove('is-not-intersecting')
                } else {
                    entry.target.classList.add('is-not-intersecting')
                    entry.target.classList.remove('is-intersecting')
                }
                if (ratio <= threshold) {
                    this.autoPauseOnScroll(entry.target.getAttribute('data-vimeo-id'), entry.target)
                } else {
                    this.autoResumeOnScroll(entry.target.getAttribute('data-vimeo-id'), entry.target)
                }
            })
        }
        let elements = document.getElementsByClassName('bd-vimeo-wrap');
        if (!elements) return
        Array.from(elements).forEach((container) => {
            let video = container.querySelector('.bd-vimeo')
            if (!video) return
            let id = video.getAttribute('data-vimeo-id') ? video.getAttribute('data-vimeo-id') : null
            if (!id) return
            let videoOptions = this.getVideoOptions(video, id)
            const player = new Vimeo.Player(video, videoOptions)
            player.on('loaded', () => {
                let playerId = oxgGenerateUniqueId();
                this.players.push({id: playerId, player: player})
                this.setOnScrollVideoOptions(video)
                if ( (video.getAttribute('data-bplusd-mute-unmute-button') != 'false') || (video.getAttribute('data-bplusd-play-pause-button') == 'false') ) {
                    this.setUpCustomControls(container, id, playerId)
                }
                if (video.getAttribute('data-observe') == 'true') {
                    let observerOptions = this.getObserverOptions(video)
                    let observer = new IntersectionObserver(observerCallback, observerOptions)
                    observer.observe(video)
                    this.observers.push({id: oxgGenerateUniqueId(), observer: observer})
                    if ( video.getAttribute('data-autoplay') == 'if-visible-on-load' ) {
                        this.autoPlayIfVisibleOnLoad(video, player)
                    }
                }
            })
            player.on('play', () => {
                video.parentNode.setAttribute('data-is-playing', 'true')
            })
            player.on('pause', () => {
                video.parentNode.setAttribute('data-is-playing', 'false')
            })
        })
    }
    setUpCustomControls(container, videoId, uniqueId) {
        if (!container) return
        let customControls = container.querySelector('.bd-video-controls')
        if( !customControls ) return
        let muteUnmuteBtn = customControls.querySelector('.mute-unmute-btn')
        if ( muteUnmuteBtn ) {
            muteUnmuteBtn.setAttribute('data-vimeo-id', videoId)
            muteUnmuteBtn.setAttribute('data-player-id', uniqueId)
            let vimeoPlayers = this.players
            muteUnmuteBtn.addEventListener('click', function() {
                muteUnmuteVimeoPlayer(muteUnmuteBtn, vimeoPlayers)
            })
        }
        let playPauseBtn = customControls.querySelector('.play-pause-btn')
        if ( playPauseBtn ) {
            playPauseBtn.setAttribute('data-vimeo-id', videoId)
            playPauseBtn.setAttribute('data-player-id', uniqueId)
            let vimeoPlayers = this.players
            playPauseBtn.addEventListener('click', function() {
                playPauseVimeoPlayer(playPauseBtn, vimeoPlayers)
            })
        }
    }
    setOnScrollVideoOptions(video) {
        if ( !video.hasAttribute('data-tipping-point') ) video.setAttribute('data-tipping-point', this.getStandardTippingPoint())
        if ( !video.hasAttribute('data-observe') ) video.setAttribute('data-observe', 'true')
    }
    getVideoOptions(video, id) {
        if (!video.hasAttribute('data-starts-muted')) video.setAttribute('data-starts-muted', 'true')
        if (video.getAttribute('data-starts-muted') == 'true') {
            video.parentNode.setAttribute('data-is-muted', 'true')
        } else {
            video.parentNode.setAttribute('data-is-muted', 'false')
        }
        if (!video.parentNode.hasAttribute('data-is-playing')) video.parentNode.setAttribute('data-is-playing', 'false')
        if( video.parentNode.getAttribute('data-is-playing') == 'false' ) {
            let playPauseBtn = video.parentNode.querySelector('.play-pause-btn')
            if( playPauseBtn ) {
                playPauseBtn.setAttribute('data-is-playing', 'false')
            }
        } else {
            let playPauseBtn = video.parentNode.querySelector('.play-pause-btn')
            if( playPauseBtn ) {
                playPauseBtn.setAttribute('data-is-playing', 'true')
            }
        }
        let autoplay = false
        if ( video.hasAttribute('data-autoplay') ) {
            if ( video.getAttribute('data-autoplay') == 'on-load' ) {
                autoplay = true
            }
            if ( video.getAttribute('data-autoplay') == 'when-loaded' ) {
                autoplay = true
            }
        }
        let object = {
            id : id,
            controls : video.hasAttribute('data-controls') ? video.getAttribute('data-controls') : true,
            muted : video.hasAttribute('data-starts-muted') ? video.getAttribute('data-starts-muted') : false,
            autoplay : autoplay ? autoplay : false,
            dnt : video.hasAttribute('data-dnt') ? video.getAttribute('data-dnt') : true,
            color : video.hasAttribute('data-color') ? video.getAttribute('data-color') : '00b0e3',
            loop : video.hasAttribute('data-loop') ? video.getAttribute('data-loop') : true,
            byline : video.hasAttribute('data-byline') ? video.getAttribute('data-byline') : false,
            portrait : video.hasAttribute('data-portrait') ? video.getAttribute('data-portrait') : false,
            responsive : video.hasAttribute('data-responsive') ? video.getAttribute('data-responsive') : true,
            background: video.hasAttribute('data-background') ? video.getAttribute('data-background') : false,
            autopause: video.hasAttribute('data-autopause') ? video.getAttribute('data-autopause') : false,
            keyboard: video.hasAttribute('data-keyboard') ? video.getAttribute('data-keyboard') : true,
            playsinline: video.hasAttribute('data-playsinline') ? video.getAttribute('data-playsinline') : true,
        }
        return object
    }
    getObserverOptions(element) {
        if (!element) return
        return {
            root: element.getAttribute('data-root') ? document.getElementById(element.getAttribute('data-root')) : null,
            rootMargin: element.getAttribute('data-root-margin') ? element.getAttribute('data-root-margin') : '-100px',
            threshold: element.getAttribute('data-threshold') ? element.getAttribute('data-threshold') : [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
    }
    getPlayerFromId(id) {
        let vimeoPlayer;
        for (let i = 0; i < this.players.length; i++) {
            let player = this.players[i].player;
            let div = player._originalElement;
            if (!div) return 
            if (div.getAttribute('data-vimeo-id') == id) {
                vimeoPlayer = player
                break
            }
        }
        return vimeoPlayer
    }
    autoPlayIfVisibleOnLoad(htmlContainerElement, vimeoPlayer, threshold = this.getStandardThreshold()) {
        if( htmlContainerElement ) {
            let visibility = visibleInViewport(htmlContainerElement, true)
            console.log(visibility)
            if ( visibility.visible && visibility.percentageVisible > 60 ) {
                vimeoPlayer.play().then(function(){console.log('a video was played, because it was set to "autoplay if visible in viewport"')})
            }
        }
    }
    autoPauseOnScroll(videoId, video) {
        let viewport = this.getViewportDimensions()
        if (viewport.width <= 992) return
        let player = this.getPlayerFromId(videoId)
        if(!player) return
        player.getPaused().then(function(paused) {
            if (!paused) {
                if (video.getAttribute('data-autopause-when-not-visible') == 'true') {
                    player.pause().then(function() { 
                        video.setAttribute('data-is-playing', 'false')
                    })
                }
            }
        })
    }
    autoResumeOnScroll(videoId, video) {
        let viewport = this.getViewportDimensions()
        let player = this.getPlayerFromId(videoId)
        if(!player) return
        player.getPaused().then(function(paused) {
            if (paused) {
                let autoplaySetting = video.getAttribute('data-autoplay')
                if (autoplaySetting == 'when-visible' || autoplaySetting == 'on-load') {
                    player.play().then(function() { 
                        video.setAttribute('data-is-playing', 'true')
                    })
                }
            }
        })
    }
    getViewportDimensions() {
        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
        return {
            width: windowWidth,
            cleanWidth: windowWidth - scrollbarWidth,
            scrollbarWidth: scrollbarWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let oxgVimeoVideos = new OxgVimeoVideos('oxgVimeoVideos');
})